import React, { FC } from "react";

import Button from "@components/Button";

const DisabledButton: FC<{ buttonText?: string }> = ({ buttonText = "Launch Course" }) => {
  return (
    <div className="disabled-button">
      <Button>{buttonText}</Button>
      {/* language=CSS */}
      <style jsx>
        {`
          :global(.disabled-button .Button) {
            cursor: not-allowed;
            background-color: #bfbfbf;
          }

          :global(.disabled-button .Button:hover) {
            background-color: #bfbfbf;
          }
        `}
      </style>
    </div>
  );
};

export default DisabledButton;
